/* This file is autogenerated, see readme.md for instructions */
import NotificationSvgIcon from '@bloomreach/banana-theme/icons/notification.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const NotificationIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <NotificationSvgIcon />
    </Icon>
  );
});

NotificationIcon.displayName = 'NotificationIcon';

export default NotificationIcon;
